import { makeAutoObservable } from "mobx";
import TagsEditorStore from "../common/tags-editor";
import NumberInKimWithThemeStore from "./number-in-kim-with-theme";
import { MathegeImportRequest, TaskService } from "../../services/task-service";
import Subjects from "../../models/subjects";
import { message } from "antd";
import Messages from "../../services/messages";
import ITask from "../../models/task";
import TaskCloneStore from "./task-clone";

export default class MathegeImportStore {

    taskService: TaskService;
    numberInKimWithTheme: NumberInKimWithThemeStore;

    tags: TagsEditorStore;
    loading: boolean;
    importedTask: number | undefined;
    task: TaskCloneStore | undefined;
    clones: TaskCloneStore[];

    constructor() {

        this.taskService = new TaskService();
        this.numberInKimWithTheme = new NumberInKimWithThemeStore(Subjects.MATH);
        this.tags = new TagsEditorStore();
        this.loading = false;
        this.importedTask = undefined;
        this.task = undefined;
        this.clones = [];

        makeAutoObservable(this);
    }

    changeImportTask(value: number | null) {
        if (value) {
            this.importedTask = value;
        }
    }

    import() {

        if (this.importedTask) {
            this.loading = true;
            this.task = undefined;
            this.clones = [];

            const params: MathegeImportRequest = {
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemAsNumber,
                theme: this.numberInKimWithTheme.theme.selectedItemAsNumber,
                tags: this.tags.getTags,
                number: this.importedTask
            };

            this.taskService.mathegeImport(
                params,
                (data) => {
                    const id = data["id"];
                    this.taskService.getById(id,
                        (data) => {
                            this.loading = false;
                            this.task = new TaskCloneStore(data as ITask, id, this.taskService);
                            this.taskService.getClones(
                                id,
                                (data) => {
                                    this.clones = (data['content'] as ITask[]).map(item => new TaskCloneStore(item, id, this.taskService));
                                    this.loading = false;
                                },
                                (error) => message.error(Messages.map(error))
                            );
                        },
                        (error) => message.error(Messages.map(error))
                    )
                },
                (error: string) => {
                    this.loading = false;
                    message.error(Messages.map(error));
                }
            );
        }
    }
}